import { Grid, Stack } from '@mui/material';
import exportFromJSON from 'export-from-json';
import { Fragment } from 'react';
import DataTable from 'react-data-table-component';
import { AuditLogReportRequest, ThresholdChangeReportItem } from '../../../model/auditlogreports';
import ReportHeader from './ReportHeader';
import ReportToolbar from './ReportToolbar';
import useThresholdChanges from '../../../hooks/AuditLogReports/useThresholdChanges';

const ThresholdChanges = ({ request, reportType, filterBy, users }: props) => {

    const { status, data, error, isFetching } = useThresholdChanges(request);

    const columns = [
        {
            name: 'User Name',
            selector: (row: ThresholdChangeReportItem) => row.userName
        },
        {
            name: 'Enrollment Group',
            selector: (row: ThresholdChangeReportItem) => row.enrollmentGroup,
        },
        {
            name: 'Serious Offender Change',
            selector: (row: ThresholdChangeReportItem) => row.seriousOffenderChange,
        },
        {
            name: 'Threshold Type',
            selector: (row: ThresholdChangeReportItem) => row.type,
        },
        {
            name: 'Threshold Change',
            selector: (row: ThresholdChangeReportItem) => row.thresholdChange,
        },
        {
            name: 'Change Result',
            selector: (row: ThresholdChangeReportItem) => row.changeResult,
        },
        {
            name: 'Changed Date',
            selector: (row: ThresholdChangeReportItem) => row.changedDate,
        },
        {
            name: 'Changed Time',
            selector: (row: ThresholdChangeReportItem) => row.changedTime,
        },
        {
            name: 'IP Address',
            selector: (row: ThresholdChangeReportItem) => row.ipAddress,
        }
    ];

    const exportThresholdChangesData = () => {
        const reportData = data || [];
        const fileName = 'ThresholdChanges';
        const exportType = exportFromJSON.types.csv;
        const fields = {
            userName: 'User Name', enrollmentGroup: 'Enrollment Group', seriousOffenderChange: 'Serious Offender Change Status',
            type: 'Threshold Type', thresholdChange: 'Threshold Change', changeResult: 'Change Result',
            changedDate: 'Changed Date', changedTime: 'Changed Time', ipAddress: 'IP Address'
        };

        exportFromJSON({
            data: reportData,
            fileName: fileName,
            fields: fields,
            exportType: exportType
        });
    };

    return (
        <Fragment>
            <Grid container>
                <Grid item xs={5}>
                </Grid>
                <Grid item xs={6}>
                    <ReportHeader reportType={reportType} filterBy={filterBy} users={users} />
                </Grid>
                <Grid item xs={1}>
                    <ReportToolbar export={exportThresholdChangesData} />
                </Grid>
            </Grid>

            <DataTable
                columns={columns}
                data={data || []}
                fixedHeader={true}
                fixedHeaderScrollHeight={'750px'}
                pagination
            />
        </Fragment>
    );
}

type props = {
    request: AuditLogReportRequest;
    reportType: any
    filterBy: any
    users: any
}

export default ThresholdChanges;